import { Component } from '@verndale/core';

class Menu extends Component {
  setupDefaults() {
    this.dom = {
      $document: $(document),
      $button: this.$el.find('.menu__button'),
      $chevron: this.$el.find('.chevron')
    };
  }

  addListeners() {
    this.dom.$button.on('click', ::this.handleClick);
    this.dom.$document.on('click', ::this.handleClickOutside);
  }

  handleClick(e) {
    this.$el.toggleClass('menu--open');
    this.dom.$chevron.toggleClass('bottom');
  }

  handleClickOutside(e) {
    if (!$(e.target).closest(this.$el).length) {
      this.$el.removeClass('menu--open');
      this.dom.$chevron.addClass('bottom');
    }
  }
}

export default Menu;
